<template>
    <div class="page-500">
        <img :src="`${cdnUrl}/static/images/500.png`">
        <div style="margin-top: 20px">
            <el-button @click="goBack">返回</el-button>
        </div>
    </div>
</template>

<script>
    export default {
		data() {
			return {
				cdnUrl: process.env.VUE_APP_BASE_CDN
			}
		},
        methods: {
            goBack () {
                history.go(-1)
            }
        }
    }
</script>
<style lang="scss" scoped>
    .page-500 {
        width: 100%;
        text-align: center;
        img {
            width: 700px;
        }
    }
</style>